import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers, ApiRoutes } from "../../../root/apiRoutes";
import { DataMapDto } from "../dto/datamap/DataMapDto";
import { PatchDataMapRequest } from "../dto/datamap/DataMapRequestDto";
import { PersonalInformationCollectedDto } from "../dto/PersonalInformationOptionsDto";

import { ApiJsonPatch, OrganizationPublicId } from "../Types";

export class DataMapController {
  constructor(private axios: AxiosInstance) {}

  public getDataMap = async (organizationId: OrganizationPublicId): Promise<DataMapDto> => {
    const url = Helpers.organization.dataMap.root(organizationId);
    const response = await this.axios.get<DataMapDto>(url);
    return response.data;
  };

  public patchDataMap = async (
    organizationId: OrganizationPublicId,
    update: PatchDataMapRequest,
  ): Promise<ApiJsonPatch> => {
    const url = Helpers.organization.dataMap.root(organizationId);
    const response = await this.axios.patch<ApiJsonPatch>(url, update);
    return response.data;
  };

  public getRecommendedCollection = async (): Promise<PersonalInformationCollectedDto> => {
    const url = ApiRoutes.dataMap.recommendedCollection;
    const response = await this.axios.get<PersonalInformationCollectedDto>(url);
    return response.data;
  };
}
